import { render, staticRenderFns } from "./IngresarDinero.vue?vue&type=template&id=6fba6a74&"
import script from "./IngresarDinero.vue?vue&type=script&lang=js&"
export * from "./IngresarDinero.vue?vue&type=script&lang=js&"
import style0 from "./IngresarDinero.vue?vue&type=style&index=0&id=6fba6a74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports